import { FormatString } from './core.js';

//let gLocalizedStrings = null;
let gLocalizedStrings = {
	ru : {
		'-90 Degrees' : '-90°',
		'1 day' : '1 день',
		'10 GB of storage instead of 1 GB, scenes up to 5 GB, and models are kept without a time limit.' : '10 ГБ хранилища вместо 1 ГБ, сцены до 5 ГБ и модели без срока хранения.',
		'90 Degrees' : '90°',
		'A link to a model is part of the subscription. On the free plan a saved model is visible only to you.' : 'Ссылка на модель входит в подписку. На бесплатном тарифе сохранённая модель видна только вам.',
		'A password is asked for once, and then the model opens as usual. Without one, everyone with the address gets in.' : 'Пароль спрашивают один раз, дальше модель открывается как обычно. Без пароля войдёт любой, у кого есть адрес.',
		'Accept' : 'Принять',
		'Account' : 'Аккаунт',
		'Add' : 'Добавить',
		'Add comment' : 'Добавить комментарий',
		'Already have an account? Sign in' : 'Уже есть аккаунт? Войдите',
		'Ambient' : 'Рассеянный свет',
		'An account keeps your models on the server: 1 GB free, a scene up to 300 MB, stored for a week.' : 'В аккаунте модели хранятся на сервере: 1 ГБ бесплатно, сцена до 300 МБ, срок хранения неделя.',
		'Anyone with the link can open this model in the viewer — no account needed. The link works while the model is stored and the subscription is paid.' : 'Кто угодно по ссылке откроет эту модель в просмотрщике — регистрация не нужна. Ссылка работает, пока модель лежит в хранилище и оплачена подписка.',
		'Asset properties' : 'Свойства файла',
		'At least 10 characters.' : 'Не короче 10 знаков.',
		'Available Files' : 'Доступные файлы',
		'Back' : 'Назад',
		'Background Color' : 'Цвет фона',
		'Background Image' : 'Изображение фона',
		'Bump Map' : 'Карта рельефа',
		'Calculate...' : 'Вычислить...',
		'Cancel' : 'Отмена',
		'Cancel upload' : 'Отменить загрузку',
		'Card payment is not connected yet. We issue an invoice and write to the account address; access is switched on once the money arrives.' : 'Оплата картой пока не подключена. Мы выставим счёт и напишем на почту аккаунта, доступ включится после поступления денег.',
		'Centimeter' : 'Сантиметр',
		'Change password' : 'Сменить пароль',
		'Check an example file:' : 'Поддерживаемые форматы',
		'Close' : 'Закрыть',
		'Collapse all' : 'Свернуть все',
		'Color' : 'Цвет',
		'Comment' : 'Комментировать',
		'Comment name' : 'Название комментария',
		'Comment text' : 'Текст комментария',
		'Comments' : 'Комментарии',
		'Company details for the invoice' : 'Реквизиты для счёта',
		'Continuing the upload that was interrupted.' : 'Продолжаем прерванную загрузку.',
		'Copied' : 'Скопировано',
		'Copy' : 'Скопировать',
		'Create' : 'Создать',
		'Create Snapshot' : 'Создать снимок экрана',
		'Create account' : 'Создать аккаунт',
		'Create snapshot' : 'Создать снимок экрана',
		'Current password' : 'Текущий пароль',
		'Custom' : 'Свой размер',
		'Dark mode' : 'Тёмная тема',
		'Default' : 'По умолчанию',
		'Default Color' : 'Цвет по умолчанию',
		'Default Line Color' : 'Цвет линий по умолчанию',
		'Delete' : 'Удалить',
		'Delete comment' : 'Удалить комментарий',
		'Delete the model?' : 'Удалить модель?',
		'Details' : 'Сведения',
		'Diffuse Map' : 'Карта диффузии',
		'Document user texts' : 'Пользовательские тексты документа',
		'Download' : 'Скачать',
		'Drag and drop 3D models here.' : 'Перетащите сюда 3D-модель.',
		'Edge Angle Threshold' : 'Порог угла граней',
		'Edge Color' : 'Цвет граней',
		'Email' : 'Почта',
		'Embedding Code' : 'Код для вставки',
		'Embedding Volumetrix in an iframe is not supported.' : 'Volumetrix нельзя открыть внутри iframe.',
		'Emissive Map' : 'Карта самосвечения',
		'Entire Model' : 'Вся модель',
		'Environment' : 'Окружение',
		'Expand all' : 'Развернуть все',
		'Export' : 'Экспорт',
		'Export Failed' : 'Не удалось экспортировать',
		'Export data' : 'Выгрузить комментарии',
		'Exporting Model' : 'Экспорт модели',
		'Extra {0} is stored. On {1}, in {2} d., the oldest models will be deleted — only as many as it takes to fit the free plan. Renew the subscription or delete what you do not need.' : 'Сверх квоты занято {0}. {1}, через {2} дн., удалятся самые старые модели — ровно столько, чтобы уложиться в бесплатный тариф. Продлите подписку или удалите ненужное.',
		'Failed to import model.' : 'Не удалось импортировать модель.',
		'Failed to load draco decoder.' : 'Не удалось загрузить декодер Draco.',
		'Failed to load file for import.' : 'Не удалось загрузить файл для импорта.',
		'Failed to load occt-import-js.' : 'Не удалось загрузить модуль occt-import-js.',
		'Failed to load rhino3dm.' : 'Не удалось загрузить модуль rhino3dm.',
		'Failed to load web-ifc.' : 'Не удалось загрузить модуль web-ifc.',
		'Failed to parse bim file.' : 'Не удалось разобрать файл BIM.',
		'Failed to read Rhino file.' : 'Не удалось прочитать файл Rhino.',
		'False' : 'Нет',
		'Files' : 'Файлы',
		'Files: {0}, together {1}' : 'Файлов: {0}, вместе {1}',
		'Fit mesh to window' : 'Вписать меш в окно',
		'Fit meshes to window' : 'Вписать меши в окно',
		'Fit model to window' : 'Вписать модель в окно',
		'Fixed up vector' : 'Вращение по осям X и Z',
		'Flat list' : 'Плоский список',
		'Flip up vector' : 'Перевернуть',
		'Foot' : 'Фут',
		'Free orbit' : 'Свободное вращение',
		'Free plan' : 'Бесплатный тариф',
		'Guid' : 'Идентификатор',
		'Height' : 'Высота',
		'Here you can load models based on their urls. You can add more lines if your model builds up from multiple files.' : 'Здесь можно открыть модели по ссылкам. Если модель состоит из нескольких файлов, добавьте строки.',
		'Hide mesh' : 'Скрыть меш',
		'Import Settings' : 'Настройки импорта',
		'Importing Model' : 'Импорт модели',
		'Importing model...' : 'Импорт модели...',
		'Inch' : 'Дюйм',
		'Info' : 'Информация',
		'Invalid glTF file.' : 'Некорректный файл glTF.',
		'Invalid glTF version.' : 'Неподдерживаемая версия glTF.',
		'Invalid header information.' : 'Некорректный заголовок файла.',
		'Invalid normal index.' : 'Некорректный индекс нормали.',
		'Invalid uv index.' : 'Некорректный индекс UV-координаты.',
		'Invalid vertex color index.' : 'Некорректный индекс цвета вершины.',
		'Invalid vertex index.' : 'Некорректный индекс вершины.',
		'Invoice {0} has been issued. The subscription starts once the money arrives.' : 'Счёт {0} выставлен. Подписка включится, когда придут деньги.',
		'Isolate mesh' : 'Изолировать меш',
		'Kept without a time limit' : 'Хранится без срока',
		'Large (2560x1440)' : 'Большой (2560x1440)',
		'Less than a day left' : 'Осталось меньше суток',
		'Light mode' : 'Светлая тема',
		'Lines' : 'Линии',
		'Link term' : 'Срок ссылки',
		'Link to the model' : 'Ссылка на модель',
		'Load data' : 'Загрузить комментарии',
		'Loading Model' : 'Загрузка модели',
		'Loading model...' : 'Загрузка модели...',
		'Loading…' : 'Загрузка…',
		'Material' : 'Материал',
		'Materials' : 'Материалы',
		'Materials ({0})' : 'Материалы ({0})',
		'Measure' : 'Измерение',
		'Medium (1920x1080)' : 'Средний (1920x1080)',
		'Mesh' : 'Меш',
		'Mesh properties' : 'Свойства меша',
		'Mesh {0}' : 'Меш {0}',
		'Meshes' : 'Меши',
		'Meshes ({0})' : 'Меши ({0})',
		'Metallic Map' : 'Карта металличности',
		'Metalness' : 'Металличность',
		'Meter' : 'Метр',
		'Millimeter' : 'Миллиметр',
		'Missing Files' : 'Отсутствующие файлы',
		'Model' : 'Модель',
		'Model Display' : 'Отображение модели',
		'Model comments' : 'Комментарии к модели',
		'Multiple importable models found. Select the model you would like to import from the list below.' : 'Найдено несколько моделей. Выберите из списка ту, которую нужно открыть.',
		'My models' : 'Мои модели',
		'Name, ИНН, КПП — or leave empty if the invoice is for a person' : 'Название, ИНН, КПП — или оставьте пустым, если счёт на физлицо',
		'New password' : 'Новый пароль',
		'No Document.xml found.' : 'Файл Document.xml не найден.',
		'No Name' : 'Без имени',
		'No Rotation' : 'Без поворота',
		'No account yet? Create one' : 'Нет аккаунта? Создайте',
		'No importable file found.' : 'Не найдено ни одного файла для импорта.',
		'No importable object found.' : 'Не найдено ни одного объекта для импорта.',
		'No time limit' : 'Без срока',
		'Nobody has opened it yet. Turning the link off stops it for good: switching sharing back on gives out a new address.' : 'Пока никто не открывал. Выключение отменяет ссылку насовсем: если включить снова, адрес будет новый.',
		'Node properties' : 'Свойства узла',
		'Normal Map' : 'Карта нормалей',
		'Nothing saved here yet. Open a model and save it to the account.' : 'Здесь пока пусто. Откройте модель и сохраните её в аккаунт.',
		'OK' : 'ОК',
		'One of the requested buffers is missing.' : 'Один из требуемых буферов отсутствует.',
		'Opacity' : 'Непрозрачность',
		'Open' : 'Открыть',
		'Open Volumetrix' : 'Открыть Volumetrix',
		'Open a saved model' : 'Открыть сохранённую модель',
		'Open from url' : 'Открыть по ссылке',
		'Open from your device' : 'Открыть с устройства',
		'Opened {0} times. Turning the link off stops it for good: switching sharing back on gives out a new address.' : 'Открывали {0} раз. Выключение отменяет ссылку насовсем: если включить снова, адрес будет новый.',
		'Orthographic camera' : 'Ортографическая камера',
		'Other sessions are closed.' : 'Остальные сессии закрыты.',
		'Password' : 'Пароль',
		'Password changed, other sessions are closed.' : 'Пароль изменён, остальные сессии закрыты.',
		'Password changed.' : 'Пароль изменён.',
		'Perspective camera' : 'Перспективная камера',
		'Phong' : 'Фонг',
		'Physical' : 'Физическая',
		'Please wait...' : 'Пожалуйста, подождите...',
		'Properties' : 'Свойства',
		'Remove isolation' : 'Убрать изоляцию',
		'Remove the password' : 'Убрать пароль',
		'Renew automatically' : 'Продлевать автоматически',
		'Renewal on {0}: we are issuing an invoice for the next period.' : 'Продление от {0}: выставляем счёт на следующий период.',
		'Repeat new password' : 'Повторите новый пароль',
		'Request accepted on {0}. We will issue an invoice and write to the account address.' : 'Заявка принята {0}. Выставим счёт и напишем на почту аккаунта.',
		'Request accepted. We will issue an invoice and write to the account address.' : 'Заявка принята. Выставим счёт и напишем на почту аккаунта.',
		'Request an invoice' : 'Запросить счёт',
		'Reset to Default' : 'Сбросить настройки',
		'Rotation' : 'Поворот',
		'Roughness' : 'Шероховатость',
		'Save' : 'Сохранить',
		'Save it again — the upload will continue from where it stopped.' : 'Сохраните ещё раз — загрузка продолжится с того места, где оборвалась.',
		'Save to account' : 'Сохранить в аккаунт',
		'Saved to the account' : 'Сохранено в аккаунт',
		'Scene name' : 'Название сцены',
		'Scene properties' : 'Свойства сцены',
		'Scope' : 'Что экспортировать',
		'Select Model' : 'Выберите модель',
		'Select a point.' : 'Выберите точку.',
		'Select another point.' : 'Выберите вторую точку.',
		'Select the format from the list below, and adjust the settings of the selected format.' : 'Выберите формат из списка ниже и настройте его параметры.',
		'Set Y axis as up vector' : 'Задать ось Y как направление вверх',
		'Set Z axis as up vector' : 'Задать ось Z как направление вверх',
		'Settings' : 'Настройки',
		'Share' : 'Поделиться',
		'Sharing Failed' : 'Не удалось поделиться',
		'Sharing Link' : 'Ссылка на модель',
		'Sharing works only if you load files by url. Please upload your model files to a web server, open them by url, and try embedding again.' : 'Поделиться можно только моделью, открытой по ссылке. Выложите файлы на сервер, откройте их по ссылке и попробуйте снова.',
		'Show Edges' : 'Показывать грани',
		'Show all meshes' : 'Показать все меши',
		'Show the comments on the model' : 'Показывать комментарии к модели',
		'Show/hide meshes' : 'Показать или скрыть меши',
		'Sign in' : 'Войти',
		'Sign out' : 'Выйти',
		'Sign out on other devices' : 'Выйти на других устройствах',
		'Size X' : 'Размер X',
		'Size Y' : 'Размер Y',
		'Size Z' : 'Размер Z',
		'Small (1280x720)' : 'Малый (1280x720)',
		'Something went wrong' : 'Что-то пошло не так',
		'Something went wrong.' : 'Что-то пошло не так.',
		'Source' : 'Источник',
		'Specular' : 'Зеркальность',
		'Specular Map' : 'Карта зеркальности',
		'Stopping…' : 'Останавливаем…',
		'Storage is over the free limit' : 'Занято больше бесплатного объёма',
		'Subscription' : 'Подписка',
		'Subscription and payment' : 'Подписка и оплата',
		'Surface' : 'Площадь',
		'The files can be downloaded from the link the same way the viewer downloads them — do not share what must not leave.' : 'Файлы по ссылке можно скачать — просмотрщик забирает их так же. Не делитесь тем, что не должно уходить.',
		'The model contains no faces.' : 'В модели нет граней.',
		'The model contains no vertices.' : 'В модели нет вершин.',
		'The model doesn\'t contain any 3D meshes. Try to save the model while you are in shaded view in Rhino.' : 'В модели нет трёхмерных мешей. Попробуйте сохранить её из Rhino в режиме затенённого отображения.',
		'The model doesn\'t contain any meshes.' : 'В модели нет мешей.',
		'The password is set' : 'Пароль установлен',
		'The passwords do not match.' : 'Пароли не совпадают.',
		'The remote server refused to fulfill the request. Check if the url is correct, and make sure that CORS requests are allowed on the remote server.' : 'Удалённый сервер отклонил запрос. Проверьте ссылку и убедитесь, что на сервере разрешены запросы CORS.',
		'The server is not responding. Try again later.' : 'Сервер не отвечает. Попробуйте позже.',
		'There were no other sessions.' : 'Других сессий не было.',
		'This model is behind a password. Ask whoever sent the link for it.' : 'Эта модель под паролем. Спросите его у того, кто прислал ссылку.',
		'This website uses cookies to offer you better user experience. See the details at the <a target="_blank" href="info/cookies.html">Cookies Policy</a> page.' : 'Сайт использует cookie, чтобы работать удобнее. Подробности — на странице <a target="_blank" href="info/cookies.html">«Использование cookie»</a>.',
		'Transparent background' : 'Прозрачный фон',
		'Tree view' : 'Дерево',
		'Triangles' : 'Треугольники',
		'True' : 'Да',
		'Turn the link off' : 'Выключить ссылку',
		'Turn the link on' : 'Включить ссылку',
		'Type' : 'Тип',
		'Unit' : 'Единица измерения',
		'Unknown' : 'Неизвестно',
		'Unknown error.' : 'Неизвестная ошибка.',
		'Unsupported extension: {0}.' : 'Неподдерживаемое расширение: {0}.',
		'Upload cancelled, nothing was saved.' : 'Загрузка отменена, ничего не сохранено.',
		'Upload cancelled.' : 'Загрузка отменена.',
		'Uploading… {0}%' : 'Загрузка… {0}%',
		'Use customized settings' : 'Учитывать текущие настройки',
		'Used {0} of {1}' : 'Занято {0} из {1}',
		'User texts' : 'Пользовательские тексты',
		'Vertex colors' : 'Цвета вершин',
		'Vertices' : 'Вершины',
		'Visible Only' : 'Только видимое',
		'Visualizing Model' : 'Отрисовка модели',
		'Visualizing model...' : 'Отрисовка модели...',
		'Volume' : 'Объём',
		'We issue the invoice for the next period {0} days before the subscription ends. Nothing is charged by itself — cards are not connected, the invoice is paid the usual way.' : 'За {0} дней до конца подписки мы сами выставим счёт на следующий период. Само ничего не списывается — карты не подключены, счёт оплачивается как обычно.',
		'What the subscription gives' : 'Что даёт подписка',
		'Whoever opens the link types the password once. Changing or removing it closes the link for everyone who has already typed the old one.' : 'Тот, кто откроет ссылку, введёт пароль один раз. Смена или снятие пароля закрывает ссылку для всех, кто уже ввёл старый.',
		'Width' : 'Ширина',
		'Will be removed within the hour' : 'Будет удалена в течение часа',
		'Works until {0}' : 'Работает до {0}',
		'a month' : 'месяц',
		'a year' : 'год',
		'per {0}' : 'за {0}',
		'will be deleted on {0}' : 'удалится {0}',
		'without a password' : 'без пароля',
		'{0} GB' : '{0} ГБ',
		'{0} KB' : '{0} КБ',
		'{0} MB' : '{0} МБ',
		'{0} d. left' : 'Осталось {0} дн.',
		'{0} days' : '{0} дней',
		'{0} for {1}' : '{0} за {1}',
		'{0} of {1}' : '{0} из {1}',
		'{0}, paid until {1}' : '{0}, оплачен до {1}',
		'«{0}» is in your account now. {1}' : '«{0}» теперь в аккаунте. {1}',
		'«{0}» will be deleted for good, with all its files.' : '«{0}» удалится насовсем, вместе со всеми файлами.'
	}
};
//let gLanguageCode = null;
let gLanguageCode = 'ru';

export function SetLocalizedStrings (localizedStrings)
{
    gLocalizedStrings = localizedStrings;
}

export function SetLanguageCode (languageCode)
{
    gLanguageCode = languageCode;
}

export function Loc (str)
{
    if (gLocalizedStrings === null || gLanguageCode === null) {
        return str;
    }

    //if (!gLocalizedStrings[str] || !gLocalizedStrings[str][gLanguageCode]) {
	if (!gLocalizedStrings[gLanguageCode] || !gLocalizedStrings[gLanguageCode][str]) {
        return str;
    }
    //return gLocalizedStrings[str][gLanguageCode];
	return gLocalizedStrings[gLanguageCode][str];
}

export function FLoc (str, ...args)
{
    return FormatString (Loc (str), ...args);
}
